<template>
  <div class="blog-home">
    <section class="hero">
      <div class="hero-copy">
        <p class="eyebrow">SUNLIT ISLE / 技术 / 生活观察</p>
        <h1>{{ siteSettings.siteName }}</h1>
        <p class="hero-text">
          收藏技术、旅途与日常灵感，也整理真正有用的经验。
        </p>
        <div class="hero-actions">
          <el-button type="primary" @click="$router.push('/articles')">浏览文章</el-button>
        </div>
      </div>
      <div class="hero-panel" :style="heroPanelStyle" aria-label="精选内容概览">
        <div class="panel-topline">
          <span>Featured</span>
          <strong>2026</strong>
        </div>
        <h2>像夏天的海风一样，把复杂事情吹清楚。</h2>
        <p>本周关注：项目整理、内容复盘、以及那些值得慢慢写下来的日常灵感。</p>
      </div>
    </section>

    <section id="articles" class="home-section-heading">
      <div>
        <p class="eyebrow">最新文章</p>
        <h2>最近发布的 3 篇文章。</h2>
      </div>
      <el-button @click="$router.push('/articles')">更多文章</el-button>
    </section>

    <div v-if="loading" class="home-state">
      <i class="el-icon-loading"></i>
      正在加载文章...
    </div>

    <section class="content-grid article-card-grid">
      <article class="post-card article-card" v-for="post in posts" :key="post.id">
        <img class="article-card-cover" :src="post.coverImage" :alt="`${post.title}封面`">
        <div class="article-card-meta">
          <time>{{ post.updatedAt }}</time>
          <span
            v-if="post.categoryName"
            class="article-card-category"
            :class="`tone-${post.categoryTone}`"
          >
            {{ post.categoryName }}
          </span>
        </div>
        <div class="article-card-body">
          <h2>{{ post.title }}</h2>
          <p v-if="post.author" class="article-card-author">作者：{{ post.author }}</p>
          <p>{{ post.summary }}</p>
        </div>
        <router-link class="article-card-link" :to="`/articles/${post.id}`">阅读全文</router-link>
      </article>
    </section>

    <el-empty v-if="!loading && posts.length === 0" description="还没有发布文章" />

  </div>
</template>

<script>
import { fetchPublicArticles } from '@/services/publicArticles';
import { DEFAULT_SITE_SETTINGS } from '@/services/siteSettings';
import { getArticleCover } from '@/utils/articles';

export default {
  name: 'BlogHome',
  props: {
    siteSettings: {
      type: Object,
      default: () => ({ ...DEFAULT_SITE_SETTINGS }),
    },
  },
  data() {
    return {
      posts: [],
      loading: false,
      size: 3,
    };
  },
  computed: {
    heroPanelStyle() {
      if (!this.siteSettings.homeHeroImageUrl) {
        return {};
      }

      return {
        '--home-hero-image': `url("${this.siteSettings.homeHeroImageUrl}")`,
      };
    },
  },
  created() {
    this.loadArticles();
  },
  methods: {
    normalizeArticle(item) {
      const categoryName = item.category?.name || '';

      return {
        id: item.id || item.articleId,
        title: item.title || '未命名文章',
        summary: item.summary || '',
        author: item.author || '',
        coverImage: getArticleCover(item.coverImage),
        updatedAt: item.publishedAt || item.updatedAt || item.updateTime || item.createdAt || '-',
        visible: item.visible !== false,
        categoryName,
        categoryTone: this.getCategoryTone(categoryName),
      };
    },
    getCategoryTone(categoryName) {
      const name = categoryName || '';
      let hash = 0;

      for (let index = 0; index < name.length; index += 1) {
        hash += name.charCodeAt(index);
      }

      return hash % 6;
    },
    extractArticles(body) {
      const data = body?.data ?? body;
      const list = Array.isArray(data)
        ? data
        : data?.records
          || data?.list
          || data?.content
          || data?.items
          || data?.rows
          || body?.records
          || body?.list;

      return Array.isArray(list)
        ? list.map(this.normalizeArticle).filter((article) => article.visible)
        : [];
    },
    extractErrorMessage(error) {
      return error.response?.data?.message
        || error.response?.data?.msg
        || error.message
        || '文章加载失败，请稍后再试';
    },
    async loadArticles() {
      this.loading = true;

      try {
        const response = await fetchPublicArticles({
          page: 1,
          size: this.size,
        });
        const posts = this.extractArticles(response.data);
        this.posts = posts.slice(0, 3);
      } catch (error) {
        this.posts = [];
        this.$message.error(this.extractErrorMessage(error));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
